module.exports = __webpack_public_path__ + "img/12ne.c0fbe875.svg";